export abstract class BaseApiService {
  baseUrl = '/api';
  baseControllerUrl: string;

  constructor(controllerBaseUrl: string) {
    this.baseControllerUrl = `${this.baseUrl}/${controllerBaseUrl}`;
  }
}
